"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type * as DialogPrimitive from "@radix-ui/react-dialog";
import * as React from "react";
import type { DialogProps as VaulDialogProps } from "vaul";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { useMediaQuery } from "@/hooks/use-media-query";
import { cn } from "@/lib/utils";
interface BaseProps {
  children: React.ReactNode;
}
type DialogProps = React.ComponentProps<typeof DialogPrimitive.Root>;
type RootCredenzaProps = BaseProps & DialogProps & VaulDialogProps;
interface CredenzaProps extends BaseProps {
  className?: string;
  asChild?: true;
}
type CredenzaContentProps = React.ComponentProps<typeof DialogContent> & React.ComponentProps<typeof DrawerContent>;
const CredenzaContext = React.createContext<{
  isDesktop: boolean;
}>({
  isDesktop: false
});
const useCredenzaContext = () => {
  const context = React.useContext(CredenzaContext);
  if (!context) {
    throw new Error("Credenza components cannot be rendered outside the Credenza Context");
  }
  return context;
};
const Credenza = t0 => {
  const $ = _c(15);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const Credenza = isDesktop ? Dialog : Drawer;
  let t1;
  if ($[3] !== isDesktop) {
    t1 = {
      isDesktop
    };
    $[3] = isDesktop;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isDesktop) {
    t2 = !isDesktop && {
      autoFocus: true
    };
    $[5] = isDesktop;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== Credenza || $[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <Credenza {...props} {...t2}>{children}</Credenza>;
    $[7] = Credenza;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <CredenzaContext.Provider value={t1}>{t3}</CredenzaContext.Provider>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
const CredenzaTrigger = t0 => {
  const $ = _c(9);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaTrigger = isDesktop ? DialogTrigger : DrawerTrigger;
  let t1;
  if ($[4] !== CredenzaTrigger || $[5] !== children || $[6] !== className || $[7] !== props) {
    t1 = <CredenzaTrigger className={className} {...props}>{children}</CredenzaTrigger>;
    $[4] = CredenzaTrigger;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
const CredenzaClose = t0 => {
  const $ = _c(9);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaClose = isDesktop ? DialogClose : DrawerClose;
  let t1;
  if ($[4] !== CredenzaClose || $[5] !== children || $[6] !== className || $[7] !== props) {
    t1 = <CredenzaClose className={className} {...props}>{children}</CredenzaClose>;
    $[4] = CredenzaClose;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
const CredenzaContent = t0 => {
  const $ = _c(9);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaContent = isDesktop ? DialogContent : DrawerContent;
  let t1;
  if ($[4] !== CredenzaContent || $[5] !== children || $[6] !== className || $[7] !== props) {
    t1 = <CredenzaContent className={className} {...props}>{children}</CredenzaContent>;
    $[4] = CredenzaContent;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
const CredenzaDescription = t0 => {
  const $ = _c(9);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaDescription = isDesktop ? DialogDescription : DrawerDescription;
  let t1;
  if ($[4] !== CredenzaDescription || $[5] !== children || $[6] !== className || $[7] !== props) {
    t1 = <CredenzaDescription className={className} {...props}>{children}</CredenzaDescription>;
    $[4] = CredenzaDescription;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
const CredenzaHeader = t0 => {
  const $ = _c(9);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaHeader = isDesktop ? DialogHeader : DrawerHeader;
  let t1;
  if ($[4] !== CredenzaHeader || $[5] !== children || $[6] !== className || $[7] !== props) {
    t1 = <CredenzaHeader className={className} {...props}>{children}</CredenzaHeader>;
    $[4] = CredenzaHeader;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
const CredenzaTitle = t0 => {
  const $ = _c(9);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaTitle = isDesktop ? DialogTitle : DrawerTitle;
  let t1;
  if ($[4] !== CredenzaTitle || $[5] !== children || $[6] !== className || $[7] !== props) {
    t1 = <CredenzaTitle className={className} {...props}>{children}</CredenzaTitle>;
    $[4] = CredenzaTitle;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
const CredenzaBody = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("px-4 md:px-0", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
const CredenzaFooter = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    isDesktop
  } = useCredenzaContext();
  const CredenzaFooter = isDesktop ? DialogFooter : DrawerFooter;
  const t1 = !isDesktop && "flex-col-reverse";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn(t1, className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== CredenzaFooter || $[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <CredenzaFooter className={t2} {...props}>{children}</CredenzaFooter>;
    $[7] = CredenzaFooter;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export { Credenza, CredenzaBody, CredenzaClose, CredenzaContent, CredenzaDescription, CredenzaFooter, CredenzaHeader, CredenzaTitle, CredenzaTrigger };